// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__rPzZj","modal":"styles_modal__s4Crp","modalBody":"styles_modalBody__YCqcj","title":"styles_title__D6a+q","close":"styles_close__8hrnL"};